import React from "react";

export const icons = {
  dollar: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon-dollar"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path>
      <line x1="12" y1="6" x2="12" y2="8"></line>
      <line x1="12" y1="16" x2="12" y2="18"></line>
    </svg>
  ),

  efficiency: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon-efficiency"
    >
      <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83"></path>
    </svg>
  ),

  resource: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon-resource"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  ),

  technology: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon-technology"
    >
      <rect x="4" y="4" width="16" height="16" rx="2"></rect>
      <line x1="8" y1="10" x2="16" y2="10"></line>
      <line x1="8" y1="14" x2="16" y2="14"></line>
    </svg>
  ),

  growth: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon-growth"
    >
      <path d="M21 7v13H3V4h13"></path>
      <path d="M16 2h6v6"></path>
      <path d="M22 2L12 12"></path>
    </svg>
  ),

  checkmark: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
  ),

  troubleshooting: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
    </svg>
  ),

  maintenance: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 16v-4M12 8h.01"></path>
      <path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16v-2"></path>
      <path d="m7.5 4.2 9 5.25M7.5 19.8l9-5.25"></path>
    </svg>
  ),

  installation: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
      <path d="M12 22.5V12M3.3 7l8.7 5 8.7-5"></path>
    </svg>
  ),

  performance: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 20V10M12 20V4M6 20v-6"></path>
    </svg>
  ),

  zeroDowntime: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="6" width="20" height="12" rx="2"></rect>
      <circle cx="12" cy="12" r="2"></circle>
      <path d="M6 12h.01M18 12h.01"></path>
    </svg>
  ),

  webPortal: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
      <line x1="8" y1="21" x2="16" y2="21"></line>
      <line x1="12" y1="17" x2="12" y2="21"></line>
    </svg>
  ),

  saas: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
    </svg>
  ),

  modernization: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 2v6h-6"></path>
      <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
      <path d="M3 22v-6h6"></path>
      <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
    </svg>
  ),

  mvp: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2v20M2 12h20"></path>
      <circle cx="12" cy="12" r="10"></circle>
    </svg>
  ),

  cms: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>
    </svg>
  ),

  ecommerce: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="21" r="1"></circle>
      <circle cx="20" cy="21" r="1"></circle>
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
    </svg>
  ),

  systemAnalysis: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
    </svg>
  ),

  architectureDesign: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>
    </svg>
  ),

  coding: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="16 18 22 12 16 6"></polyline>
      <polyline points="8 6 2 12 8 18"></polyline>
    </svg>
  ),

  integration: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
      <polyline points="15 3 21 3 21 9"></polyline>
      <line x1="10" y1="14" x2="21" y2="3"></line>
    </svg>
  ),

  rollout: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
      <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
      <line x1="12" y1="22.08" x2="12" y2="12"></line>
    </svg>
  ),

  futureDesign: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2v20M2 12h20"></path>
      <circle cx="12" cy="12" r="10"></circle>
    </svg>
  ),

  customerFirst: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 1 0 7.75"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),

  costEffective: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 20V10"></path>
      <path d="M18 20V4"></path>
      <path d="M6 20v-6"></path>
    </svg>
  ),

  modernTech: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
    </svg>
  ),

  security: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon-security"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
};

export const services = [
  {
    id: "managed-it",
    title: "Managed IT Services",
    mainHeading: "Managed IT Services",
    caseStudyDescription:
      "24x7 Network Operations Center for Monitoring & Support To Ensure Maximum Network Uptime.",
  },
  {
    id: "co-managed-it",
    title: "Co-Managed IT Services",
    mainHeading: "Co-Managed IT Services",
    caseStudyDescription:
      "Optimizing IT Resources Through Trusted Collaboration.",
  },
  {
    id: "server-administration",
    title: "Infrastructure Management",
    mainHeading: "Infrastructure Management",
    caseStudyDescription:
      "Proactive Server Administration That Powers Business Continuity.",
  },
  {
    id: "infrastructure-management",
    title: "Infrastructure Management",
    mainHeading: "Infrastructure Management",
    caseStudyDescription:
      "Create an infrastructure that is always ready for any opportunity.",
  },
  {
    id: "network-monitoring",
    title: "Network Monitoring",
    mainHeading: "Network Monitoring",
    caseStudyDescription: "Smart Monitoring for Smarter Networks.",
  },
  {
    id: "vapt-assessment",
    title: "VAPT Assessment",
    mainHeading: "Vulnerability Assessment & Penetration Testing",
    caseStudyDescription:
      "Comprehensive security testing to identify and address vulnerabilities in your systems.",
  },
  {
    id: "application-development",
    title: "Application Development",
    mainHeading: "Application Development",
    caseStudyDescription:
      "Custom software development services tailored to your specific business needs, from web applications and mobile apps to enterprise solutions that drive efficiency and digital transformation.",
  },
  {
    id: "why-choose-us",
    title: "当社を選ぶ理由",
    mainHeading: "Why Choose Us",
  },
];

export const getServiceById = (id) => {
  return services.find((service) => service.id === id);
};

export const storyPageContent = {
  pageTitle: "クライアントの成功事例 ",
  bannerTitle: "クライアントの成功事例 ",
  bannerImage:
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-1.2.1&auto=format&fit=crop&w=2850&q=80",
  sectionTitle: "クライアントの成功事例 ",
  headings: {
    clientBackground: "Client Background",
    opportunity: "Opportunity",
    challenges: "Challenges",
    solution: "Solution & Success",
  },
  successAchieved: "Success Achieved",
  ctaSectionTitle: "Ready to Achieve Similar Results?",
  ctaSectionDescription:
    "Contact us today to discuss how we can help your organization overcome challenges and achieve success.",
  ctaButtonText: "Contact Us Today",
  heroContent: {
    title: "Success Stories",
    subtitle: "Real Results, Real Impact",
    description:
      "Discover how our services have helped organizations transform their IT infrastructure and achieve their business goals.",
    image: "/lovable-uploads/e6694f95-019b-49d3-b745-6e955541e110.png",
    alt: "Success Stories",
    primaryButtonText: "お問い合わせ ",
    primaryButtonLink: "/contact",
  },
};

export const successStories = [
  {
    id: 1,
    industry: "Fintech Solutions for Digital Finance",
    title: "Digital Payment Solutions Provider",
    clientBackground:
      "Our client is part of Japan's leading publicly listed company, pioneering in digital payment solutions. The company develops and provides user-friendly system tools and services for both online merchants and end customers, allowing e-commerce businesses to focus on their core operations.",
    opportunity:
      "Our customer expected services beyond simple monitoring. They were looking for a partner (and not vendor) who can run a dedicated offshore center with a dedicated team. One of their earlier vendor provided them a shared monitoring support, with shared resources. They wanted a partner who can support them in application release activities too.",
    challenges:
      "Keeping the infra up and running 24×7 was crucial being one of the leading payment gateway solutions providers in Japan. Senior Management was on constant standby during critical times.",
    solution:
      "Started with a phased approach. Within 4 months, we scaled up to 24 × 7 monitoring support. Within 6 months we could handle in application release activities also. Resources planning and capacity expansion rollouts.",
    results:
      "Customer could focus more on infrastructure and/or application improvements. They could onboard several new merchants that resulted in the increase of revenue by 21%.",
  },
  {
    id: 2,
    industry: "Retail Banking",
    title: "Payment Service Provider",
    clientBackground:
      "A publicly listed Payment Service Provider in Japan, ensures secure and efficient financial transactions for businesses, including 24x7 convenience stores nationwide. Operating two critical verticals—System Operations (SysOpe) and Monitoring—the client supports uninterrupted payment processing while meeting industry standards and compliance requirements.",
    opportunity:
      "The client sought to enhance operational efficiency in handling scheduled tasks (e.g., IFRS financial reporting) and request-based tasks. Ensure 24x7 monitoring of alerts to maintain high availability of applications and infrastructure, critical for uninterrupted payment services. Streamline infrastructure management, including adapting workflows for a smooth transition from on-premises to the cloud.",
    challenges:
      "Task Overload: Managing a high volume of scheduled and request-based tasks, often leading to a backlog. Uptime Pressure: Ensuring uninterrupted services for 24x7 convenience stores where even minor downtime could impact operations. Alert Management: Handling over 900+ types of alerts across applications and infrastructure, leading to prioritization challenges.",
    solution:
      "SysOpe Optimization: Implemented a task management system to streamline scheduled tasks and prioritize backlog tasks effectively. Automated repetitive processes for tasks like IFRS reporting, improving efficiency and accuracy. Monitoring Enhancements: Introduced a priority-based framework to respond to critical alerts to ensure faster resolution. Established centralized workflows via Slack and real-time dashboards to monitor alerts seamlessly.",
    results:
      "Improved operational efficiency and reduced response times for critical alerts, ensuring uninterrupted service delivery.",
  },
  {
    id: 3,
    industry: "Digital Payment",
    title: "Digital Payment Service Provider",
    clientBackground:
      "A publicly listed Payment Service Provider in Japan, ensures secure and efficient financial transactions for businesses, including 24x7 convenience stores nationwide. Operating two critical verticals—System Operations (SysOpe) and Monitoring—the client supports uninterrupted payment processing while meeting industry standards and compliance requirements.",
    opportunity:
      "The client sought to enhance operational efficiency in handling scheduled tasks (e.g., IFRS financial reporting) and request-based tasks. Ensure 24x7 monitoring of alerts to maintain high availability of applications and infrastructure, critical for uninterrupted payment services. Streamline infrastructure management, including adapting workflows for a smooth transition from on-premises to the cloud.",
    challenges:
      "Task Overload: Managing a high volume of scheduled and request-based tasks, often leading to a backlog. Uptime Pressure: Ensuring uninterrupted services for 24x7 convenience stores where even minor downtime could impact operations. Alert Management: Handling over 900+ types of alerts across applications and infrastructure, leading to prioritization challenges.",
    solution:
      "SysOpe Optimization: Implemented a task management system to streamline scheduled tasks and prioritize backlog tasks effectively. Automated repetitive processes for tasks like IFRS reporting, improving efficiency and accuracy. Monitoring Enhancements: Introduced a priority-based framework to respond to critical alerts to ensure faster resolution. Established centralized workflows via Slack and real-time dashboards to monitor alerts seamlessly.",
    results:
      "Achieved significant reduction in alert response times and improved operational efficiency.",
  },
];

export const whyChooseUs = {
  bannerTitle: "当社を選ぶ理由",
  bannerSubtitle:
    "当社のマネージド サービスを利用してテクノロジーを加速し、ビジネスの成長を促進しましょう。",
  sections: [
    {
      title: "当社のセキュリティへの取り組み",
      content:
        "DG FutureTech では、お客様のデータの保護を最優先に考えています。当社は、組織、運用、ポリシーの各レベルにわたって強力なセキュリティ対策を実施し、お客様のデータ、アプリケーション、インフラストラクチャを確実に保護して、ビジネスの安全性と回復力を維持します。",
    },
    {
      title: "ビジネスの成功に向けたITの強化",
      content:
        "今日のデジタル世界では、IT インフラストラクチャとアプリケーションがビジネスの基盤を形成します。コア システムからカスタム アプリケーションに至るまで、信頼性が高く、拡張性と柔軟性に優れたテクノロジー環境は、ビジネス目標を達成し、顧客の期待を上回る能力に直接影響します。",
    },
  ],
  callToAction: {
    text: "Ready to transform your IT infrastructure? Let our experts help you build a scalable, secure, and efficient technology foundation for your business.",
    buttonText: "Get Started",
  },
};

export const servicesData = {
  title: "Bridging Connections, Crafting Co-Value!",
  services: [
    {
      title: "Proactive Maintenance",
      description:
        "Proactively Avoiding Disruptions. DG FutureTech uses advanced 24x365 monitoring. Proactive maintenance prevents costly disruptions and extends the life of your IT assets.",
    },
    {
      title: "Regular Security Audits",
      description:
        "Ensuring Continuous Protection. Our Regular Security Audits are designed to identify vulnerabilities and strengthen your systems, ensuring maximum protection against threats. We use industry best practices to safeguard your business.",
    },
    {
      title: "Expertise & Scalability",
      description:
        "End-to-End Expertise and Scalability. With our expertise, we ensure that your IT infrastructure is scalable and ready for future growth. From small startups to large enterprises, we provide solutions tailored to your needs.",
    },
    {
      title: "Cost Saving",
      description:
        "Reducing Operational Costs. Our solutions are designed to minimize IT-related costs while maintaining high-quality services. We help you optimize your budget by implementing cost-effective strategies and leveraging cutting-edge technologies.",
    },
  ],
};

export const itServices = [
  {
    id: 1,
    title: "マネージドITソリューション",
    description:
      "エキスパートが管理するITサービスによるシームレスなパフォーマンスを体験してください。プロアクティブな監視と拡張性のあるソリューションにより、運用は安全かつ効率的に実施され、ビジネスを中断させることなく成長させ、戦略目標に完全に集中できるようになります。",
    iconClass: "securityIcon",
    path: "/managed-services",
  },
  {
    id: 2,
    title: "共同管理ITサービス",
    description:
      "12年以上のITサービス管理の経験を持つDG FutureTechは、お客様の社内ITチームと連携してインフラストラクチャのパフォーマンスを強化し、余分な作業負荷に対処してユーザー満足度を向上させます。",
    iconClass: "consultingIcon",
    path: "/co-managed-it-services",
  },
  {
    id: 3,
    title: "インフラ管理",
    description:
      "DG FutureTechのサーバー管理サービスにより、サーバーが常にオンラインで安全かつ最新の状態に保たれます。 当社は24時間365日の監視とエキスパートによるサポートを提供し、ダウンタイムを最小限に抑えてビジネスを護ります。",
    iconClass: "digitalIcon",
    path: "/infrastructuremanagement",
  },
  {
    id: 4,
    title: "ネットワーク管理",
    description:
      "DG FutureTechは、ビジネスがシームレスに運営されるよう、24時間365日をカバーするネットワーク監視を提供します。当社の専門チームは、潜在的な問題に積極的に対処し、ネットワークを最適化して最高のパフォーマンスを実現することで、信頼性の高いソリューションを提供します。 ",
    iconClass: "cloudIcon",
    path: "/networkmonitoring",
  },

  {
    id: 5,
    title: "VAPT評価",
    description:
      "当社では、Web、モバイル、クラウドシステムのエンドツーエンドの脆弱性評価と侵入テスト（VAPT）を提供し、セキュリティリスクを特定して修正します。当社のプロセスにより、セキュリティ体制の改善、サイバー脅威の軽減、実行可能な修復措置が保証されます。", 
      iconClass: "cloudIcon",
    path: "/vapt-assessment",
  },
  {
    id: 6,
    title: "アプリケーション開発",
    description:
      "ビジネスニーズに合わせたカスタムアプリケーション開発により、スケーラブルで安全、かつユーザーフレンドリーなソリューションを提供し、イノベーションを推進、運用を効率化して、プラットフォーム全体のデジタルトランスフォーメーションを加速します。",
    iconClass: "cloudIcon",
    path: "/application-development",
  },
];

export const clientTestimonials = [
  {
    id: 1,
    description:
      "Vizitech（現 DG FutureTech）との提携は素晴らしい経験でした。彼らの革新性、技術面の専門知識、そして卓越性への取り組みは、まさに世界クラスです。彼らは、プロフェッショナルな姿勢で、高品質なソリューションを時間通りに提供します。",
    name: "ハビエル グアルド 様",
    designation: "ケンボル ベンチャーズ",
  },
  {
    id: 2,
    description:
      "DG FutureTechチームの「ノーと言わない」姿勢、粘り強さ、そして献身に感謝します。彼らのおかげで、私たちは現在の24時間365日稼働する運用監視センターを構築することができました。誠にありがとうございました。",
    name: "綿貫 様",
    designation: "DGフィナンシャルテクノロジー　部長",
  },
  {
    id: 3,
    description:
      "DG FutureTechのチームは、私のビジョンを、魅力的で高性能なWebサイトに変換してくれました。Webベースのオーディオおよびビデオプラットフォームは素晴らしく、すべてのユーザーが簡単にアクセスできます。",
    name: "スニル カレ 様",
    designation: "モチベーションスピーカー",
  },
  {
    id: 4,
    description:
      "優れたモバイルアプリ開発！DG FutureTechチームは、私たちのニーズに合わせてシームレスでユーザーフレンドリーなアプリを提供してくれました。プロフェッショナルで信頼性が高く、高度なスキルを備えているため、最高品質の仕事に非常におすすめです。",
    name: "ハンニ パティル 様",
    designation: "セピア イノベーションズCEO",
  },
  {
    id: 5,
    description:
      "Pravin氏とDG FutureTechチームとの協業は大変喜ばしいものでした。彼らは私たちのニーズを迅速に理解し、ウェブサイトのロジックの改良からサードパーティAPIの統合まで、的確な成果を上げてくれました。彼らのプロ意識、迅速な対応、そして仕事の質の高さには本当に感銘を受けました。今後の協業を楽しみにしています。",
    name: "ラジェシュ ドゥーム 様",
    designation: "ディレクター Carloana",
  },
];

export const getSuccessStoryById = (id) => {
  return successStories.find((story) => story.id === parseInt(id));
};

export const itServicesData = [
  {
    id: 1,
    title: "オフショアでのリーズナブルなソフト開発",
    content:
      "ビジネスアプリケーションのスクラッチ開発をリーズナブルに。バイリンガルエンジニアがお客様と要求仕様をしっかり確認し、開発はリーズナブルなインドで実施します。",
    img: "/assets/images/betteritservice/Comprehensive IT Services 1.jpg",
  },
  {
    id: 2,
    title: "包括的なITマネージドサービス",
    content:
      "お客様の業界のニーズに合わせた開発、運用、監視サービスを含むエンドツーエンドのITソリューションを提供します。",
    img: "/assets/images/betteritservice/Strong Security Compliance.jpg",
  },
  {
    id: 3,
    title: "エンジニアリング人材の活用",
    content:
      "優れた技術力と日英バイリンガル能力を併せ持ったインドの専門エンジニアチームはが、貴社に優れたソリューションを提供します。",
    img: "/assets/images/betteritservice/Demand for Skilled IT Talent.png",
  },
  {
    id: 4,
    title: "強力なセキュリティコンプライアンス",
    content:
      "ISO-27001:2022やPCI-DSSなどのグローバル規格に準拠し、お客様のビジネス資産を保護します。",
    img: "/assets/images/betteritservice/Leveraging Engineering Talent.jpg",
  },
];

export const footerText = {
  "footer-heading": "DG FutureTech India Pvt. Ltd.",
  "footer-heading-one": "Who we are",
  "footer-heading-two": "Services",
  "footer-detail-one": "Application Development",
  "footer-detail-two": "Infrastructure Management",
  "footer-detail-three": "Managed Sevices",
  "footer-detail-four": "Consulting Services",
  //"footer-heading-three": "成功事例",
  "footer-heading-three": "ケーススタディ",
  "footer-detail-five": "Implementation",
  "footer-heading-four": "お問い合わせ",
  "footer-detail-six": "Privacy Policy",
  "footer-detail-seven": "Digital Garage Group",
  "footer-detail-eight":
    "DG FutureTech, a Digital Garage company. 無断複写・転載を禁じます。",
  "footer-detail-twentytwo":"This site is protected by the Google Privacy Policy and Terms of Service apply.",
  "footer-detail-nine": "デジタルファイナンスのためのフィンテックソリューション ",
  "footer-detail-ten": "リテールバンキング ",
  "footer-detail-eleven": "デジタル決済サービスプロバイダー ",
  "footer-detail-eleven1": "スマートカーローンプラットフォーム ",
  "footer-detail-eleven2": "Webアプリケーションの基盤移行 ",
  "footer-detail-twelve": "Co-Managed IT Services",
  "footer-detail-thirteen": "Network Monitoring",
  "footer-detail-fourteen": "Server Administration",
  "footer-detail-fifteen": "FAQ",
  "footer-detail-sixteen": "Security Assessment",
  "footer-detail-nineteen": "Success Stories",
  "footer-detail-twenty": "Life at DG FutureTech",
  "footer-detail-twentyone": "VAPT Assessment",
  "footer-garage": "Digital Garage Group",
  "footer-test": "Security Assessment",
};

export const fetchBenefits = () => {
  return [
    {
      title: "Innovation at Heart",
      description:
        "We go beyond keeping pace—we set trends. Our team thrives on exploration, discovery, and lifelong learning. Embracing new tools and ideas keeps us sharp and ready for tomorrow’s challenges.",
      icon: "💡 ",
    },
    {
      title: "Collaboration Over Hierarchy",
      description:
        "We succeed through unity, not structure. Teams work seamlessly across roles, locations, and time zones. Clear communication and shared goals build strong partnerships wherever we are.",
      icon: "🤝 ",
    },
    {
      title: "Integrity & Accountability",
      description:
        "We stand by our commitments and values. Trust, honesty, and ownership guide every action—whether we’re collaborating with each other or delivering results for our clients and stakeholders.",
      icon: "✅ ",
    },
    {
      title: "Unified by Differences",
      description:
        "Our strength lies in our diversity. We embrace experiences and ideas—because the best solutions come from a mix of perspectives. Our culture empowers us all to grow, create, and lead with purpose.",
      icon: "🌍",
    },
    {
      title: "Purpose-Driven Work",
      description:
        "We align every initiative with a clear vision: using technology to make a difference. Our dedication to impact drives the way we design, build, and deliver meaningful digital experiences.",
      icon: "🎯 ",
    },
  ];
};

export const fetchTestimonials = () => {
  return [
    {
      name: "Sarah Johnson",
      role: "Senior Developer",
      quote:
        "Working at DG FutureTech has been transformative for my career. The collaborative environment and cutting-edge projects keep me engaged and growing every day.",
      image:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=250",
    },
    {
      name: "Michael Chen",
      role: "Product Manager",
      quote:
        "What sets DG FutureTech apart is how they value innovation and personal growth. I've been able to lead exciting projects while developing new skills.",
      image:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=250",
    },
    {
      name: "Aisha Patel",
      role: "UX Designer",
      quote:
        "The creative freedom and supportive team at DG FutureTech have allowed me to do the best work of my career. It's a place where design is truly valued.",
      image:
        "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=250",
    },
    {
      name: "James Wilson",
      role: "Data Scientist",
      quote:
        "I joined for the challenging problems, but stayed for the amazing culture. DG FutureTech invests in both cutting-edge technology and its people.",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=250",
    },
  ];
};

export const fetchLocations = () => {
  return [
    {
      city: "Pune",
      address:
        "Office No.5, Gokhale Sanchit, BMCC Rd, 846 Shivajinagar, Pune 411004, India",
      image:
        "https://images.unsplash.com/photo-1567529692333-de9fd6772897?q=80&w=500",
      mapEmbed:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.2033262746622!2d73.83779729999999!3d18.5197117!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf1d1ae843cb%3A0x8d00c432536a3548!2sDG%20FutureTech%20India%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1743652739656!5m2!1sen!2sin",
    },
    {
      city: "Tokyo",
      address:
        "Digital Gate Bldg., 3-5-7 Ebisu Minami, Shibuya-ku, Tokyo 150-0022, Japan",
      image:
        "https://images.unsplash.com/photo-1551641506-ee5bf4cb45f1?q=80&w=500",
      mapEmbed:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.2485933755306!2d139.7036923!3d35.64624639999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b4689f7a449%3A0x662273f7372970f3!2sDigital%20Garage!5e0!3m2!1sen!2sin!4v1746602211128!5m2!1sen!2sin",
    },
  ];
};

export const fetchGalleryImages = () => {
  return [
    {
      src: require("../assets/Moments/life@dg-img1.webp"),
      alt: "Annual company retreat",
    },
    {
      src: require("../assets/Moments/life@dg-img2.webp"),
      alt: "Annual company retreat",
    },
    {
      src: require("../assets/Moments/life@dg-img3.webp"),
      alt: "Office celebration",
    },
    {
      src: require("../assets/Moments/Lif@dgft.webp"),
      alt: "Team building activity",
    },
    {
      src: require("../assets/Moments/life@dg-img4.webp"),
      alt: "Product launch event",
    },
    {
      src: require("../assets/Moments/life@dg-img5.webp"),
      alt: "Community volunteering",
    },
    {
      src: require("../assets/Moments/life@dg-img6.webp"),
      alt: "Community volunteering",
    },
    {
      src: require("../assets/Moments/life@dg-img7.webp"),
      alt: "Community volunteering",
    },
  ];
};

export const fetchAboutContent = () => {
  return {
    title: "Deciding. Experiencing. Thriving. Together.",
    subtitle:
      "Culture isn't just a buzzword—it's the backbone of everything we do. We know that a values-driven culture creates real impact. A positive, mission-focused workplace boosts innovation, teamwork, and long-term growth—for both our employees and the businesses we support.",
    description: [
      "Our team is our greatest strength. We nurture a culture of inclusion where everyone feels valued and heard. From tackling intricate tech issues to crafting standout applications, our people work together and grow as one.",
    ],
    images: [
      "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=500",
      "https://images.unsplash.com/photo-1497215842964-222b430dc094?q=80&w=500",
      "https://images.unsplash.com/photo-1558222218-b7b54eede3f3?q=80&w=500",
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=500",
    ],
  };
};

export const fetchFacilityContent = () => {
  return {
    title: "Our Stunning Facility",
    subtitle:
      "Our modern workspace is designed to inspire creativity, foster collaboration, and make work enjoyable.",
    mainImage:
      "https://images.unsplash.com/photo-1604328698692-f76ea9498e76?q=80&w=1200",
    description:
      "From flexible work areas and cutting-edge meeting rooms to relaxation zones and game spaces, our facilities are built to support both productivity and wellbeing. We believe that great environments lead to great work.",
  };
};

export const fetchMediaContent = () => {
  return {
    pressReleases: [
      {
        title: "DG FutureTech Announces New Cloud Services",
        description:
          "DG FutureTech has launched a suite of innovative cloud services designed to help businesses scale effectively.",
      },
      {
        title: "Digital Transformation Success Stories",
        description:
          "Learn how our clients have successfully navigated their digital transformation journeys with DG FutureTech.",
      },
      {
        title: "DG FutureTech Recognized as Industry Leader",
        description:
          "DG FutureTech has been recognized as a leader in IT services by industry analysts for the third consecutive year.",
      },
      {
        title: "The Future of AI in Business Operations",
        description:
          "Our CTO discusses how artificial intelligence is transforming modern business operations and what to expect in the coming years.",
      },
    ],
  };
};

export const fetchSecurityAssessmentQuestions = () => {
  return [
    {
      id: 1,
      text: "Do you have access management processes?",
      icon: "FaUserShield",
    },
    {
      id: 2,
      text: "Do you use AD Authentication?",
      icon: "FaLock",
    },
    {
      id: 3,
      text: "Do you have MFA enabled?",
      icon: "FaKey",
    },
    {
      id: 4,
      text: "Do you monitor bandwidth?",
      icon: "FaChartLine",
    },
    {
      id: 5,
      text: "Do you monitor your sites?",
      icon: "FaDesktop",
    },
    {
      id: 6,
      text: "Do you have endpoint security?",
      icon: "FaShieldAlt",
    },
    {
      id: 7,
      text: "Do you have incident management?",
      icon: "FaExclamationTriangle",
    },
    {
      id: 8,
      text: "Do you monitor network traffic?",
      icon: "FaNetworkWired",
    },
    {
      id: 9,
      text: "Do you know your attackers?",
      icon: "FaUserSecret",
    },
    {
      id: 10,
      text: "Is confidential info restricted?",
      icon: "FaFileAlt",
    },
  ];
};

export const timelineData = [
  {
    year: "2012",
    description: "Vizitech 設立。",
    position: "top",
    yearBgColor: "#082044",
    descBgColor: "#E0F7FA",
    lineColor: "#1A6CE7",
  },
  {
    year: "2016",
    description:
      "チームを拡大、シフト制でオフショア作業を開始しました。",
    position: "bottom",
    yearBgColor: "#0E3B81",
    descBgColor: "#FFF3E0",
    lineColor: "#FF9800",
  },
  {
    year: "2017",
    description:
      "2社のクライアントに対して24時間365日のサポートを提供するべく、1日2交代シフト制に、後に3交代制にチームを拡大しました。",
    position: "top",
    yearBgColor: "#1B6CE7",
    descBgColor: "#F1F8E9",
    lineColor: "#8BC34A",
  },
  {
    year: "2019",
    description: "チームは成長し、テクノロジーサポートを拡大させました。",
    position: "bottom",
    yearBgColor: "#082044",
    descBgColor: "#FCE4EC",
    lineColor: "#EC407A",
  },
  {
    year: "2021",
    description:
      "Vizitech は DG Financial Technology Japanに加わり、チームは35名にまで拡大。",
    position: "top",
    yearBgColor: "#0E3B81",
    descBgColor: "#E8EAF6",
    lineColor: "#3F51B5",
  },
  {
    year: "2022",
    description: "Vizitech は社名を DG FutureTech India に変更。",
    position: "bottom",
    yearBgColor: "#1B6CE7",
    descBgColor: "#FFF8E1",
    lineColor: "#FFC107",
  },
  {
    year: "2023",
    description: "日本支社を設立。",
    position: "top",
    yearBgColor: "#082044",
    descBgColor: "#E0F2F1",
    lineColor: "#26A69A",
  },
  {
    year: "2024",
    description: "アプリケーション開発部門発足。",
    position: "bottom",
    yearBgColor: "#1B6CE7",
    descBgColor: "#FFF8E1",
    lineColor: "#FFC107",
  },
  {
    year: "2025",
    description: "チームは 100 名規模にまで拡大しました。",
    position: "top",
    yearBgColor: "#082044",
    descBgColor: "#E0F2F1",
    lineColor: "#26A69A",
  },
];

export const fetchPrivacyPolicy = () => {
  return {
    title: "Privacy Policy",
    content: [
      {
        type: "paragraph",
        text: 'THIS PRIVACY POLICY ("PRIVACY POLICY") SETS FORTH HOW DG FUTURETECH TECHNOLOGY PVT.LTD. uses and protects the personal information AND CONFIDENTIAL INFORMATION that THE User (AS DEFINED BELOW) PROVIDES TO US when the User uses this Website. THIS PRIVACY POLICY APPLIES ONLY TO PERSONAL INFORMATION AND CONFIDENTIAL INFORMATION COLLECTED ON THE WEBSITE. THIS PRIVACY POLICY DOES NOT APPLY TO INFORMATION COLLECTED BY US IN OTHER WAYS, INCLUDING OFFLINE INFORMATION. PLEASE READ THIS PRIVACY POLICY CAREFULLY. BY CONTINUING TO USE THE SERVICES OR ACCESS THE WEBSITE, THE USER AGREES TO THIS PRIVACY POLICY. IF THE USER DOES NOT AGREE TO THIS PRIVACY POLICY, THE USER MAY NOT AVAILTHE SERVICES OR ACCESS THE WEBSITE.',
      },
      {
        type: "heading",
        text: "INTRODUCTION",
      },
      {
        type: "paragraph",
        text: 'We, DG FutureTech ("DG FutureTech"; "we"; "us"; "our") provide managed services information can be accessed through our official website https://dgfuturetech.com/ ("Website"). The service facilitates the Users ("User", "you", "your").',
      },
      {
        type: "paragraph",
        text: "For the provisions of the Services, DG FutureTech shall collect certain Personal Information (defined below) of the Users. The User shall also share certain Confidential Information with DG FutureTech while availing the Services. We are committed to protect such Personal Information and Confidential Information shared with us and have made this Privacy Policy to describe the procedures we adhere to for collecting, using, and disclosing the Personal Information and Confidential Information. We recommend the Users to read this Privacy Policy carefully so that the Users understand our approach towards the use of their Personal Information and Confidential Information. We comply with the applicable data protection regulations including in particular the Swiss Federal Act on Data Protection (FADP) and, to the extent applicable, the EU General Data Protection Regulation (GDPR). DG FutureTech acts both as a processor and as a controller as defined in the FADP and the GDPR.",
      },
      {
        type: "heading",
        text: "GOVERNING STATUTE",
      },
      {
        type: "paragraph",
        text: "This Privacy Policy is governed by and is compliant with the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules 2011, which is designed to protect the Personal Information; and other applicable rules and regulations related to privacy.",
      },
      {
        type: "heading",
        text: "PERSONAL INFORMATION COLLECTED",
      },
      {
        type: "paragraph",
        text: 'This Privacy Policy applies to Personal Information and Confidential Information collected and controlled by DG FutureTech, about the Users, when they use and register on the Website, for the Services. For availing the Services, the Users are required to share/upload certain Personal Information. For the purposes of this Privacy Policy, "Personal Information" means information that can be used to personally identify the User, including but not limited to the User\'s name, e-mail address, debit/credit card details which may include without limitation card holder name, card number, card expiry date, bank details, bank account details, or other financial information, digital wallet details, any other details required under the applicable payment mechanism and similar other information. "Confidential Information" shall mean the information contained in the documents provided for translation.',
      },
      {
        type: "heading",
        text: "NON-PERSONAL INFORMATION",
      },
      {
        type: "paragraph",
        text: "We collect the User's Internet Protocol (\"IP\") addresses when the User visits the Website to track and aggregate non-personal information. Non-personal information may include the browser name, the type of electronic device, manufacturer, make, model, unique ID of the electronic device and technical information about the User's means of connection to our Website, such as the operating system and the Internet service providers utilized and other similar information.",
      },
      {
        type: "heading",
        text: "LEGAL GROUNDS FOR PROCESSING PERSONAL INFORMATION",
      },
      {
        type: "subheading",
        text: "Contract",
      },
      {
        type: "paragraph",
        text: "We may process Personal Information in order to perform our contractual obligations or take steps linked to a contract with you or your organization. This includes:",
      },
      {
        type: "list",
        items: [
          "To provide and administer Services as instructed by you or your organization;",
          "To process payments, billing and collection; and",
          "To process applications for employment.",
        ],
      },
      {
        type: "subheading",
        text: "Consent",
      },
      {
        type: "paragraph",
        text: "We may rely on your freely given consent at the time you provided your Personal Information to us:",
      },
      {
        type: "list",
        items: [
          "To provide you with information about our company and Services.",
        ],
      },
      {
        type: "subheading",
        text: "Legitimate interests",
      },
      {
        type: "paragraph",
        text: "We may rely on legitimate interests based on our evaluation that the processing is fair, reasonable and balanced. These include:",
      },
      {
        type: "list",
        items: [
          "To administer and manage our relationship with you, including accounting, auditing, and taking other steps linked to the performance of our business relationship including identifying persons authorized to represent our clients, suppliers or service providers;",
          "To carry out background checks, where permitted;",
          "To analyze and improve our Services and communications and other systems and to monitor compliance with our policies and standards;",
          "To protect the security of our communications and other systems and to prevent and detect security threats, frauds or other criminal or malicious activities;",
          "To collect information about your preferences to personalize and improve the quality of our communications with you; and",
          "To seek for qualified candidates.",
        ],
      },
      {
        type: "heading",
        text: "USE OF PERSONAL INFORMATION",
      },
      {
        type: "paragraph",
        text: "We shall use the Personal Information and Confidential Information in the following cases:",
      },
      {
        type: "list",
        items: [
          "to provide the User with the Services and to assist the User in the event the User needs any additional support;",
          "for creation or development of business intelligence or data analytics in relation to the Services provided by DG FutureTech;",
          "to improve the Services;",
          "to assist the User with technical difficulties that may arise in relation to the User's use and access of the Website;",
          "to manage our relationship with the User;",
          "for internal record keeping; and",
          "to comply with our legal or statutory obligations.",
        ],
      },
      {
        type: "heading",
        text: "LINKS TO OTHER WEBSITES/APPLICATIONS",
      },
      {
        type: "paragraph",
        text: "Our Website may contain links to other websites/applications of the User's interest. However, once the Users have used these websites/applications through our Website, the User should note that we do not have any control over such other websites/applications. Therefore, we cannot be responsible for the protection and privacy of an information which the User provides whilst visiting such websites/applications and those are not governed by this Privacy Policy.",
      },
      {
        type: "heading",
        text: "DISCLOSURES",
      },
      {
        type: "paragraph",
        text: "We do not sell, rent, share, distribute, lease or otherwise provide the User's Personal Information to third parties, without the User's prior consent. Keeping this in mind, the User understands and agrees that we may disclose the User's Personal Information in the following cases:",
      },
      {
        type: "list",
        items: [
          "Administrators: We may provide access to the User's Personal information to any of our authorized administrators for an internal business purpose, who shall be under confidentiality obligations towards the same.",
          "Affiliates: We may provide the Personal Information we collect to our affiliates.",
          "Advertisements and promotions: We may provide the Personal Information collected on the Website to our Service Providers for advertisement and promotional purposes.",
          "Service Providers: We may share the User's Personal Information to the service providers, who are working with us in connection with the operation of the Services or the Website.",
          "Merger or Acquisition: We may transfer the User's Personal Information if we are acquired by/we acquire or merge with another company or transfer a part of our business.",
          "Legal and Regulatory Authorities: We may be required to disclose the User's Personal Information due to legal or regulatory requirements.",
        ],
      },
      {
        type: "heading",
        text: "CROSS-BORDER TRANSFERS",
      },
      {
        type: "paragraph",
        text: "We store your Personal Information outside of Switzerland and the European Union. As your Personal Information is transferred to and stored at a destination outside of Switzerland and the European Union, we take all steps reasonably necessary to ensure that such transfer and storage is in accordance with this Privacy Policy and the applicable data protection legislation to safeguard your privacy.",
      },
      {
        type: "heading",
        text: "DATA RETENTION",
      },
      {
        type: "paragraph",
        text: "We will retain the User's Personal Information and Confidential Information for as long as it is required to be retained for the purpose of provision of the Services. We may also retain and use the User's Personal Information and Confidential Information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements.",
      },
      {
        type: "heading",
        text: "SECURITY",
      },
      {
        type: "paragraph",
        text: "The User's Personal Information and Confidential Information is stored at Amazon Web Services (AWS). Although we provide appropriate firewalls and protections, we cannot warrant the security of any Personal Information or Confidential Information transmitted as our systems are not hack proof.",
      },
      {
        type: "heading",
        text: "YOUR DATA PROTECTION RIGHTS",
      },
      {
        type: "paragraph",
        text: "You have rights that you can exercise under certain circumstances with respect to your Personal Information that we hold. To exercise your rights, please send an email to support@dgfuturetech.com.",
      },
      {
        type: "list",
        items: [
          "Right to Access to Your Personal Information",
          "Right to Amendment of Your Personal Information",
          "Right to Withdraw Consent",
          "Right to Erasure of Your Personal Information",
          "Right to Restriction of Processing",
          "Right to Portability of Your Personal Information",
          "Right to Object to Processing",
          "Right to Lodge a Complaint with a Supervisory Authority",
        ],
      },
      {
        type: "heading",
        text: "COOKIES",
      },
      {
        type: "paragraph",
        text: "This Website uses cookies to improve the user experience and ensure that it is functioning effectively. Cookies are small text files that are downloaded to your device by visiting the Website. We use both session cookies (which expire once you close your web browser) and persistent cookies (which stay on your device for a set period of time or until you delete them).",
      },
      {
        type: "heading",
        text: "INDEMNIFICATION",
      },
      {
        type: "paragraph",
        text: "The User agrees to indemnify us, our subsidiaries, affiliates, officers, agents and employees and hold us harmless from and against any claims and demand, including reasonable attorneys' fees, made by any third party due to arising out of or relating to: (i) accuracy and correctness of Personal Information and the Confidential Information that the User submits or shares through the Website; (ii) the User's violation of this Privacy Policy.",
      },
      {
        type: "heading",
        text: "LIMITATION OF LIABILITY",
      },
      {
        type: "paragraph",
        text: "The User expressly understands and agrees that DG FutureTech shall not be liable for any direct, indirect, incidental, special, consequential or exemplary damages, including but not limited to, damages for loss of profits, goodwill, use, data, information, details or other intangible losses (even if DG FutureTech has been advised of the possibility of such damages), arising out of this Privacy Policy.",
      },
      {
        type: "heading",
        text: "RESERVATION OF RIGHTS",
      },
      {
        type: "paragraph",
        text: "All rights not expressly granted in this Privacy Policy are reserved by DG FutureTech and its licensors, as the case may be. Nothing contained in this Privacy Policy shall be construed as conferring by implication, estoppels or otherwise any license or right under any copyright, patent, trademark or other intellectual property right of DG FutureTech or any other person or to the User.",
      },
      {
        type: "heading",
        text: "GOVERNING LAWS AND DISPUTES",
      },
      {
        type: "paragraph",
        text: "This Privacy Policy shall be construed and governed by the laws of India without regard to principles of conflict of laws. Any dispute arising, between the Users and DG FutureTech shall be submitted to the arbitration to be conducted in Pune, India in English language, in accordance with the rules of Arbitration and Conciliation Act of 1996, by a sole arbitrator, who shall be appointed by DG FutureTech and the award made in pursuance thereof shall be binding on the Users and DG FutureTech.",
      },
      {
        type: "heading",
        text: "CHANGES TO THIS POLICY",
      },
      {
        type: "paragraph",
        text: "We may update this Privacy Policy without notice to the User. The Users are encouraged to check this Privacy Policy on a regular basis to be aware of the changes made to it. This Privacy Policy was last modified on 14 August 2019.",
      },
      {
        type: "heading",
        text: "お問い合わせ",
      },
      {
        type: "paragraph",
        text: "If the Users have any questions or concerns or grievances regarding this Privacy Policy, the User can email us at our grievance email-address support@dgfuturetech.com.",
      },
    ],
  };
};
